import React, { useState } from 'react'
import { useHistory } from 'react-router-dom';
import sendEventToEventLogs from '../helpers/events';
import { initializeCleverTap, pushEventToCleverTap } from '../utils/clevertap';
import { getFieldKey } from './helperFunctions';

function getBaseUrl() {
	if (window.location.hostname == 'localhost')
		return ('https://affinity.medibuddy.in')
	else
		return (window.location.origin);

}
function getKey() {
	if (getBaseUrl().includes('affinity.medibuddy.in')) {
		return process.env.REACT_APP_RAZORPAY_LIVE_SECRET_KEY
	}
	else
		return process.env.REACT_APP_RAZORPAY_TEST_SECRET_KEY

}
function loadScript(src) {
	return new Promise((resolve) => {
		if (window.Razorpay) {
			resolve(true);
			return;
		}
		const script = document.createElement('script')
		script.src = src
		script.onload = () => {
			resolve(true)
		}
		script.onerror = () => {
			resolve(false)
		}
		document.body.appendChild(script)
	})
}

const __DEV__ = document.domain === 'localhost'


async function displayRazorpay(packageId, packageName, price, values, master_policy_no
	, pmEntityId, members, walletAmount, metaData, isCouponCodeFlow = false, payLater, baseURl, trackingId, itemUniqueId, discountedprice, setValues, setDiscountedprice, setDiscounttext, memberFormConfig = null) {
	console.log("trackuniqudis", trackingId, itemUniqueId, discountedprice)



	const res = await loadScript('https://checkout.razorpay.com/v1/checkout.js')

	if (!res) {
		alert('Razorpay SDK failed to load. Are you online?')
		return
	}
	const obj = {
		paymentSuccess: false
		, transactionId: null
		, message: null
	};

	try {
		let timeNowInSecound = new Date().getTime();
		let transactionId = values.mobile + "-" + packageId + "-" + timeNowInSecound;
		const data = await addAffinityUserDetails(packageId, packageName, price, values, master_policy_no
			, pmEntityId, members, walletAmount, metaData, isCouponCodeFlow, payLater, transactionId, trackingId, itemUniqueId, setValues, setDiscountedprice, setDiscounttext, memberFormConfig);

		if (data["success"] == 0 && trackingId==null) {
			obj.message = "Cannot Process Your request at this time, Please try again ";
			alert("Cannot process your request ")
			return obj;
		}

		let applicableOffer = [];
		let alowedIINs = [];
		if (packageId == '4706') { //bob platimum
			//applicableOffer = bankOfBarodaOfferConfig.platinumDebitCard;
			alowedIINs = ['536018', '552230', '652331', '652505', '652211', '652196', '508781', '652220', '608234'
				, '652230', '608259', '817567', '652358', '434669', '431393', '437706', '420416']
		}
		else if (packageId == '4707') { //bob sapphire
			//applicableOffer = bankOfBarodaOfferConfig.sapphireDebitCard;
			//alowedIINs:['40265700'];
		}
		else if (packageId == '4708') {// bob opulence
			//applicableOffer = bankOfBarodaOfferConfig.opulenceDebitCard;
			// alowedIINs['40274100'];
		}

		if(trackingId && itemUniqueId && discountedprice){
			price=discountedprice
		}

		let requestBody = {
			"packageId": packageId,
			"paymentType": "AffinityPackage",
			"totalAmount": price,
			"netPaidAmount": price,
			"cashbackAmount": "0",
			"discountPercent": "0.0",
			"discountedAmount": price,
			"payment_data_net_paid_amount": price,
			"payment_data_discount_percent": "0",
			"platform": "web",
			"id": data.data.id,
			"transactionId": transactionId,
			"offers": applicableOffer,
			"phone": values.mobile
		}


		const requestOptions = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(requestBody)
		};

		const affinityResponsedata = await fetch(getBaseUrl() + '/patientswebapp/pay/affinityInitiate', requestOptions)
			.then((t) => {
				return t.json();
			})
		let confirmationData = {};

		if ((affinityResponsedata.hasOwnProperty('status') && affinityResponsedata.status == false) ||
			(affinityResponsedata.netPaidAmount && price != affinityResponsedata.netPaidAmount)) {
			alert('Cannot Process This request at this time')
			return obj;
		}
		let paymentId = affinityResponsedata.paymentId;
		const source = localStorage.getItem('source');

		// ref : https://razorpay.com/docs/payments/payment-gateway/web-integration/standard/configure-payment-methods/sample-code/
		let bob_payment_config = {
			display: {
				blocks: {
					bob: {
						name: "Pay using Bank of Baroda Platinum, Sapphire or Opulence debit cards",
						instruments: [
							{
								method: "card",
								//issuers: ["BARB"], //Bank code for BOB 
								networks: ["MasterCard", "Visa", "RuPay"],
								types: ["debit"],
							}
						]
					},
				},
				sequence: ["block.bob"],
				preferences: {
					show_default_blocks: false // Should Checkout show its default blocks?
				}
			}
		}
		if( packageId == '4706'){
			bob_payment_config = {
				display: {
					blocks: {
						bob: {
							name: "Pay using Bank of Baroda Platinum, Sapphire or Opulence debit cards",
							instruments: [
								{
									method: "card",
									//issuers: ["BARB"], //Bank code for BOB 
									networks: ["MasterCard", "Visa", "RuPay"],
									types: ["debit"],
									iins: [...alowedIINs]
								}
							]
						},
					},
					sequence: ["block.bob"],
					preferences: {
						show_default_blocks: false // Should Checkout show its default blocks?
					}
				}
			}
		}


		var options = {
			key: getKey(),
			currency: 'INR',
			order_id: affinityResponsedata.merchantId,
			"prefill": {
				"email": values.email,
				"contact": values.mobile,
			},

			handler: async function (response) {
				console.log("pm-> " + pmEntityId)
				let storageBody = response;
				storageBody.transactionId = paymentId;
				storageBody.razorpay_order_id=affinityResponsedata.merchantId;
				storageBody.phonenumber = values.mobile;
				storageBody.email = values.email;
				storageBody.gender = values.gender;
				storageBody.name = values.name;
				storageBody.userId = data.data.id;
				storageBody.pmEntityId = pmEntityId;
				storageBody.walletAmount = walletAmount;
				storageBody.usersource = 'landingPage';
				if(trackingId){
					storageBody.trackingId=trackingId
				}

				const requestOptions = {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify(storageBody)
				};
				let form_data = {
					transaction_id: paymentId,
					packageId: packageId,
					PackageName: packageName,
					username: values.name,
					email: values.email,
					phonenumber: values.mobile,
					city: values.city,
					pincode: values.pincode,
					address: values.addLine1 + values.addLine2,
					walletAmount: walletAmount,
					price: price
				}

				confirmationData = await fetch(getBaseUrl() + '/patientswebapp/affinity/paymentReceived', requestOptions).then((t) =>
					t.json()
				)

				const reqBody = {
					"name": values.name,
					"email": values.email,
					"mobileNumber": values.mobile,
					"packageName": packageName,
					"paymentStatus": "success",
					"pmEntityId": pmEntityId,
					"amount": price
				}
				const reqOptions = {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify(reqBody)
				};
				console.log("REQ", reqBody)
				const commres = fetch(getBaseUrl() + '/patientswebapp/affinity/affinityPaymentConfirmationComms', reqOptions);

				obj.paymentSuccess = true;
				sendEventToEventLogs("AFFINITY_PAYMENT_SUCCESSFUL", { packageId: packageId })
				if (confirmationData.success == 1) {
					obj.message = "Payment Successful, Your transaction id is   " + paymentId
				}
				else {
					obj.message = "Payment Processing, Your transaction id is   " + paymentId
				}
				initializeCleverTap();
				gtag("event", "purchase_done", form_data);
				form_data.source = localStorage.getItem("source")
				pushEventToCleverTap("Affinity Payment Completed", form_data)
				alert(obj.message);
				window.location.replace((baseURl ? baseURl : '/home') + '?utm_source=' + localStorage.getItem("source"));
			}
		}


		//For Bank of Baroda only
		if (pmEntityId == '11197200') {
			options = {
				config: bob_payment_config
				, ...options
			}
		}
		else if (pmEntityId == '11175149') {
			options = {
				config: {
					display: {
						hide: [
							{
								method: 'paylater'
							},
							{
								method: 'emi'
							}
						]
						, preferences: {
							show_default_blocks: true,
						},
					}
				}
				, ...options
			}
		}

		const paymentObject = new window.Razorpay(options)
		paymentObject.open()
		paymentObject.on('payment.failed', function (_response) {
			const requestBody = {
				"name": values.name,
				"email": values.email,
				"mobileNumber": values.mobile,
				"packageName": packageName,
				"paymentStatus": "failed",
				"pmEntityId": pmEntityId,
				"amount": price
			}
			const requestOptions = {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.Stringify(requestBody)
			};
			console.log("REQ", requestBody)
			const commres = fetch(getBaseUrl() + '/patientswebapp/affinity/affinityPaymentConfirmationComms', requestOptions);

			// console.log(commres);


			alert('Payment Failed');


		});
		return obj;


	}
	catch (e) {
		console.log("e" + e)
		if(trackingId==null){
			obj.message = "Cannot Process Your request at this time, Please try again 2";
			alert(obj.message);
		}
		return obj;
	}
}
const calculateAge = (dob) => {
	const birthDate = new Date(dob);
	const today = new Date();
	let age = today.getFullYear() - birthDate.getFullYear();
	const monthDiff = today.getMonth() - birthDate.getMonth();
	if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
	  age--;
	}
	return age;
}
async function addAffinityUserDetails(packageId, _packageName, _price, values, master_policy_no, pmEntityId, members, walletAmount, metaData, isCouponCodeFlow = false, payLater, transactionId, trackingId, itemUniqueId, setValues, setDiscountedprice, setDiscounttext, memberFormConfig = null) {
	const obj = {
		paymentSuccess: false
		, transactionId: null
		, message: null
	};
	const beneficiaryData = {}
	const defaultMemberFields = [
		{ key: 'name', type: 'text' },
		{ key: 'email', type: 'text' },
		{ key: 'mobile', type: 'text' },
		{ key: 'gender', type: 'radio' },
		{ key: 'relationship', type: 'select' },
		{ key: 'dob', type: 'date' }
	];
	const memberFields = (memberFormConfig && Array.isArray(memberFormConfig) && memberFormConfig.length > 0)
		? memberFormConfig.map(field => ({ key: getFieldKey(field), type: field.type || 'text' }))
		: defaultMemberFields;
	const maxMembers = members ? Number(members) : 1;
	for (let i = 2; i <= maxMembers; i++) {
		const memberData = {};
		let hasAnyValue = false;
		memberFields.forEach(({ key, type }) => {
			const valueKey = `member_${key}${i}`;
			if (values[valueKey] !== undefined && values[valueKey] !== null && values[valueKey] !== '') {
				if (type === 'date') {
					memberData[key] = dobConversion(values[valueKey]);
				} else {
					memberData[key] = values[valueKey];
				}
				hasAnyValue = true;
			}
		});
		if (hasAnyValue) {
			const memberKey = `additionalMember${i - 1}`;
			if (Object.keys(memberData).length === 1 && memberData.name) {
				beneficiaryData[memberKey] = memberData.name;
			} else {
				beneficiaryData[memberKey] = memberData;
			}
		}
	}
	if (metaData) {
		beneficiaryData['metaData'] = metaData;
	}
	console.log("walletVal" + walletAmount)
	const address = values.Address || (values.addLine1 || '') + (values.addLine2 || '') || null
	const requestBodyFormContent = {

		master_policy_no: master_policy_no,
		packageId: values.id,
		master_policy_holder: 'Medibuddy',
		proposer_name: values.name,
		proposer_dob: values.dob? dobConversion(values.dob) : null,
		gender: values.gender,
		mobilenumber: values.mobile,
		email: values.email,
		policy_start: new Date(),
		no_of_members: (members) ? members : 1,
		policy_tenure: "1 Year",
		policy_sum_insured: (values.sum_insured) ? values.sum_insured : null,
		additionalMemberData: (beneficiaryData) ? beneficiaryData : null,
		packageId: packageId,
		city: values.city,
		pincode: values.pincode,
		address: address,
		walletAmount: walletAmount,
		payment_mode: isCouponCodeFlow ? 'COUPONCODE' : "",
		transactionId: isCouponCodeFlow ? values.coupon : transactionId,
		coupon_code: values.coupon ? values.coupon: values.discountcoupon,
		usersource: 'landingPage',
		extraInfo: {
			storecode: values.storecode
		},
		entityId:pmEntityId,
		price:_price,
		trackingId:trackingId,
		itemUniqueId:itemUniqueId,
		nomineeDetails: {
			...(values.nomineeName && { name: values.nomineeName }),
			...(values.nomineeRelation && { relation: values.nomineeRelation }),
			...(values.nomineeDob && { age: calculateAge(values.nomineeDob) }),
			...(values.nomineeDob && { dob: values.nomineeDob }),
		},
		referralCode: values.referralCode,
		uniqueGovtID: values.uniqueID,
		state: values.state,
		payLater: payLater,
		id: values.id
	}

		requestBodyFormContent.extraInfo = localStorage.getItem('details') ? { "agentDetails": JSON.parse(localStorage.getItem('details')) } :  (localStorage.getItem('utm_medium') ? { "utm_medium": localStorage.getItem('utm_medium') } : {})
		const empCodeValue = values.employeeCode || values.empCode;
		if (empCodeValue) {
			requestBodyFormContent.extraInfo = { ...requestBodyFormContent.extraInfo, "employeeCode": empCodeValue };
		}
		if (values.branchType) {
			requestBodyFormContent.extraInfo = { ...requestBodyFormContent.extraInfo, "branchType": values.branchType };
		}
		if (values.branchCode) {
			requestBodyFormContent.extraInfo = { ...requestBodyFormContent.extraInfo, "branchCode": values.branchCode };
		}
		requestBodyFormContent.extraInfo = values.customerid
		? { ...requestBodyFormContent.extraInfo, customerId: values.customerid }
		: requestBodyFormContent.extraInfo;
	console.log("requestBodyFormContent  ", requestBodyFormContent);
	const requestOptionsFormContent = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify(requestBodyFormContent)
	};

	const data = await fetch(getBaseUrl() + '/patientswebapp/affinity/fillForm'
		, requestOptionsFormContent)
		.then((t) =>
			t.json()

		)

	if (data["success"] == 0 && trackingId) {
		alert("Please validate the discount coupon again")
		setValues(prevValues => ({
			...prevValues,
			discountcoupon: ""
		}));
		setDiscountedprice(null)
		setDiscounttext("null")
		return data
	}
	if (data["success"] != 0 && isCouponCodeFlow) {
		obj.message = "Thanks for placing your request with MediBuddy. Your Wellness Benefits will be activated within 48 hours after validity check. In case of any queries , please write to us at hello@medibuddy.in or call us at 080 4568 6596. ";
		alert("Thanks for placing your request with MediBuddy. Your Wellness Benefits will be activated within 48 hours after validity check. In case of any queries , please write to us at hello@medibuddy.in or call us at 080 4568 6596.")
		return data;
	}
	else if (data["success"] == 0 && isCouponCodeFlow) {
		obj.message = "Cannot Process Your request at this time, Please try again ";
		alert("Cannot process your request ")
		return data;
	}
	return data;

}

function dobConversion(dateStr) {
    let dateObj = new Date(dateStr); 

    let month = dateObj.getMonth() + 1; 
    let day = dateObj.getDate();
    let year = dateObj.getFullYear();

    return [
        day.toString().padStart(2, '0'),
        month.toString().padStart(2, '0'),  
        year
    ].join('-');
  }


export { displayRazorpay, getBaseUrl, addAffinityUserDetails, dobConversion, calculateAge };
